import React from 'react'
import {
  Image,
  Text,
  Title,
  Content,
  Container,
  ImgContainer,
}from './Card.styles'

export default function Card() {
  return (
    <Container>
      <ImgContainer>
      <Image src="../images/image-qr-code.png" alt="barcode"/>
      </ImgContainer>

      <Content>
        <Title>Improve your front-end <br/>skills by building projects</Title>
        <Text>Scan the QR code to visit Frontend Mentor and take your coding skill to the next level</Text>
      </Content>

    </Container>
  )
}
